import comment from './index'
import add from './add'
import result from './result'

export default [{
    path: '/comment',
    name:'comment',
    component: comment,
    children: [
        {
            path: '/add',
            name: 'post-comment',
            component: add
        },
        {
            path: '/result',
            name: 'post-result',
            component: result
        }
    ]
}]
